import React, { useEffect } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useAuth } from '../context/AuthContext';
import AuthNavigator from './AuthNavigator';
import MainTabNavigator from './MainTabNavigator';
import InboxScreen from '../screens/InboxScreen';
import NotificationsScreen from '../screens/NotificationsScreen';
import WalletScreen from '../screens/WalletScreen';
import SpinnerScreen from '../screens/SpinnerScreen';

const Stack = createNativeStackNavigator();

export default function AppNavigator() {
  const { isAuthenticated, restoreSession } = useAuth();

  useEffect(() => {
    restoreSession();
  }, []);

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      {!isAuthenticated ? (
        <Stack.Screen name="Auth" component={AuthNavigator} />
      ) : (
        <>
          <Stack.Screen name="Main" component={MainTabNavigator} />
          <Stack.Screen name="Inbox" component={InboxScreen} options={{ animation: 'slide_from_right' }} />
          <Stack.Screen name="Notifications" component={NotificationsScreen} options={{ animation: 'slide_from_right' }} />
          <Stack.Screen name="Wallet" component={WalletScreen} options={{ animation: 'slide_from_right' }} />
          <Stack.Screen name="Spinner" component={SpinnerScreen} options={{ animation: 'fade', presentation: 'transparentModal' }} />
        </>
      )}
    </Stack.Navigator>
  );
}
